//import { GameResult } from '../round-result.ts';
//import { Road } from './road.ts';
//import { wrapColumn, wrapRow } from './shared.ts';
//import { tie_add, tie_in } from '../Utility.js';

import Road from './road.js';
import { wrapColumn, wrapRow } from './shared.js';
import { tie_add, tie_in } from '../Utility.js';

function generateBigRoadItemList(roundResults) {
    return roundResults
        .map(res => {
        if (res.gameResult === 0){//GameResult.Tie) {
            let arr = tie_in();
            if (!arr.includes(res.order))
                tie_add(res.order);
        }
        return res.gameResult !== 0//GameResult.Tie
            ? {
                order: res.order,
                result: res.result,
                gameResult: res.gameResult,
                pairResult: res.pairResult,
            }
            : undefined;
    })
        .filter((result) => typeof result !== 'undefined');
}
function generateBigRoadGraph(roundResults, rowCount, columnCount) {
    return wrapRow(wrapColumn(generateBigRoadItemList(roundResults), (previousItem, currentItem) => previousItem.gameResult === currentItem.gameResult), rowCount, columnCount);
}
class BigRoad extends Road {
    // Todo: simplify
    constructor(row, column, roundResults) {
        super(row, column, roundResults);
        this.row = row;
        this.column = column;
        this.roundResults = roundResults;
        this.array = generateBigRoadGraph(roundResults, row, column);
    }
}

export {BigRoad, generateBigRoadItemList, generateBigRoadGraph}
